export const paths = {
  any: '*',
  root: '/',
  dashboard: '/dashboard',
  documents: {
    root: '/documents',
    any: '/documents/*',
    preview: '/documents/preview/:documentId',
    document: '/documents/document/:documentId',
  },
  login: '/login',
  savings: '/savings',
  services: '/services',
  locations: '/locations',
  upcomingEvents: '/upcoming-events',
  chat: '/chat',
  teamMembers: '/team-members',
  account: '/account',
  billing: '/billing',
  vendors: '/vendors',
  about: '/about',
  reports: '/reports',
  subsidiaryOrganization: '/subsidiary-organization',
  tickets: {
    employee: {
      any: '/:orgId/tickets/*',
      root: '/:orgId/tickets',
      details: '/:orgId/tickets/:ticketId',
      children: {
        details: ':ticketId',
      },
    },
    client: {
      root: '/tickets',
    },
  },
  help: '/help',
  billPay: '/bill-pay',
  contractTerms: '/contract-terms',
  notFound: '/not-found',
} as const;
